import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-shrink: 0;\n  margin-left: ", "px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  min-width: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { ellipsis } from 'polished';
import { size } from '@scp/ui-shared/theme/variables';
import { IconButton } from '@scp/ui-shared/components/buttons';
import { Heading1 } from '@scp/ui-shared/components/typography';
export var HeaderButton = styled(IconButton)(_templateObject());
export var ContentWrapper = styled.div(_templateObject2());
export var Heading = styled(Heading1).attrs({
  noMargin: true
})(_templateObject3(), ellipsis());
export var SecondaryActions = styled.div(_templateObject4(), size.gutterSmall);